import { FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { Formik } from '@/types';
import { TurmaModel } from '@/features/list-turma/types';
import { useTurnos } from '@/features/list-turno/api/getTurno.ts';
import { TurnoModel } from '@/features/list-turno/types';

type ListTurnoProps = {
  formik: Formik | any;
  name: string;
  required?: boolean;
  turmaId: string | number;
  serieId: string | number;
}

const ListTurno: React.FC<ListTurnoProps> = ({ formik, name, required = true, serieId, turmaId }) => {

  const { data } = useTurnos(String(serieId ?? ''), turmaId ? String(turmaId) : undefined);
  const error = required && formik.touched[name] && formik.errors[name];

  return (
    <FormControl sx={{ '.MuiSvgIcon-root': { color: 'rgba(68, 68, 68, 1)' } }} fullWidth error={error}>
      <Typography mb={'7px'}>Turno*</Typography>
      <Select
        id={name}
        name={name}
        required
        sx={{ color: '#000', border: '1px solid #000' }}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched[name] && !!formik.errors[name]}
      >
        <MenuItem key={''} value={null}>{''}</MenuItem>
        {
          data?.map((item: TurnoModel) => <MenuItem
            key={String(item.id)}
            value={item.id}>{`${item.nome}`}</MenuItem>)
        }
      </Select>
      {
        formik.touched[name] &&
        formik.errors[name] &&
        <FormHelperText>{formik.errors[name]}</FormHelperText>
      }
    </FormControl>
  );
};

export default ListTurno;